export const cars = [
  {
    nome: "Cronos",
    valor: 97480,
    imagem: "https://iili.io/J78BkiX.png",
  },
  {
    nome: "Fastback",
    valor: 121980,
    imagem: "https://iili.io/J78BeVt.png",
  },
  {
    nome: "Rampage",
    valor: 244790,
    imagem: "https://iili.io/J78B8fn.png",
  },
  {
    nome: "Renegade",
    valor: 125990,
    imagem: "https://iili.io/J78BSls.png",
  },
  {
    nome: "Strada",
    valor: 112990,
    imagem: "https://iili.io/J78BUUG.png",
  },
];
